import { Expose, Type, plainToClass } from "class-transformer";

export enum AirPayoutStatus {
  ACTIVE = "active",
  INELIGIBLE = "ineligible",
  ELIGIBLE = "eligible",
  PAYOUT_FAILED = "payout_failed",
  PROCESSING_PAYMENT = "processing_payment",
  PAYOUT_SUCCESSFUL = "payout_successful",
  UNKNOWN = "unknown",
  PAYOUT_RETURNED = "payout_returned",
  PARTNER_ERROR = "partner_error",
  UNREGISTERED = "unregistered",
  MANUAL_VERIFICATION_PENDING = "manual_verification_pending",
}

export interface IAirPayoutJourney {
  id: number;
  status: AirPayoutStatus;
  journeyId: number;
  payoutAllowed?: boolean;
  payoutUpdateAllowed?: boolean;
  name: string;
  payoutRequested: boolean;
  payoutAmount: number;
  disruptionType: "cancelation_only" | "cancelation_delay_diversion";
  coverageType: "outbound_or_inbound" | "outbound_only";
  ipidVersion?: string;
}

export class AirPayoutJourney implements IAirPayoutJourney {
  @Expose() id: number;
  @Expose() status: AirPayoutStatus;
  @Expose() journeyId: number;
  @Expose() payoutAllowed: boolean;
  @Expose() payoutUpdateAllowed: boolean;
  @Expose() name: string;
  @Expose() payoutRequested: boolean;
  @Expose() payoutAmount: number;
  @Expose() disruptionType: "cancelation_only" | "cancelation_delay_diversion";
  @Expose() coverageType: "outbound_or_inbound" | "outbound_only";
  @Expose() ipidVersion: string;

  @Type(() => Boolean)
  get outboundOnly(): boolean {
    return this.coverageType === "outbound_only";
  }

  @Type(() => Boolean)
  get cancelationOnly(): boolean {
    return this.disruptionType === "cancelation_only";
  }
}

export function transformToAirPayoutJourneyClass(airPayoutData: IAirPayoutJourney): AirPayoutJourney {
  return plainToClass(AirPayoutJourney, airPayoutData);
}
